module.exports = __webpack_public_path__ + "static/media/animal-01.31b486c9.mp3";